import { render, staticRenderFns } from "./myAccounting.vue?vue&type=template&id=2f4ae2c5&"
import script from "./myAccounting.vue?vue&type=script&lang=js&"
export * from "./myAccounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports